module.exports = __webpack_public_path__ + "static/media/stamp_9.e4efd933.png";